"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorMonitor = exports.ErrorMonitorContextProvider = exports.ErrorMonitorContext = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.ErrorMonitorContext = react_1.default.createContext({
    captureException: () => {
        return;
    },
});
const ErrorMonitorContextProvider = ({ exceptionReporter, children, }) => {
    return (react_1.default.createElement(exports.ErrorMonitorContext.Provider, { value: { captureException: exceptionReporter } }, children));
};
exports.ErrorMonitorContextProvider = ErrorMonitorContextProvider;
const useErrorMonitor = () => {
    return react_1.default.useContext(exports.ErrorMonitorContext);
};
exports.useErrorMonitor = useErrorMonitor;
//# sourceMappingURL=ErrorMonitorContext.js.map